import { ApplicationState } from 'ducks/application-state';

export const selectBlogAll = (state: ApplicationState) => state.blog.list;
export const selectBlogDetail = (state: ApplicationState) => state.blog.detail;
export const selectBlogPagination = (state: ApplicationState) => state.blog.pagination;
export const selectBlogSort = (state: ApplicationState) => state.blog.sort;
export const selectBlogLoading = (state: ApplicationState) => state.blog.loading;
